<footer>
	<p>A lot of the information on this site can be found in an informative book titled: <a [appLink]="'https://christbeforejesus.com/'">Christ Before Jesus</a>. Written by Matthew Britt and Jaaron Wingo. Check them out on <a [appLink]="'https://www.tiktok.com/@christbeforejesus'">TikTok</a>.</p>
	<div class="shareURL">
	@if (qrCode && address) {
		@if (canCopy) {
		<div (click)="copyLink()">Copy address to clipboard.</div>
		}
		<div><img [appBiggen]="{ 'size': 'max(3dvw, 3dvh)', 'axis': 'full' }" [src]="qrCode" [alt]="address" [title]="address" /></div>
	}
	</div>
</footer>